import script from "./FiloxeniaIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./FiloxeniaIcon.vue?vue&type=script&setup=true&lang=ts"

import "./FiloxeniaIcon.vue?vue&type=style&index=0&id=27be6464&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27be6464"]])

export default __exports__